import { message, Modal } from 'antd';
import { API, PATH } from 'data';
import { useNavigate } from 'react-router-dom';
import { RestAPI, useAsyncClick } from 'scripts';

export default function PostDeleteComp({ slug, open, onClose }: { slug: string; open: boolean; onClose: () => void }) {
    const navigate = useNavigate();
    const onRemove = useAsyncClick(() => {
        return new Promise((resolve) => {
            RestAPI.delete(API.posts.detailAdmin(slug))
                .then(() => {
                    message.success('پست شما با موفقیت حذف شد.');
                    navigate(PATH.panel.myAds.index());
                })
                .catch(() => message.error('حذف پست با خطا مواجه شد. لطفا بعدا تلاش کنید.'))
                .finally(() => resolve(true));
        });
    });

    return (
        <Modal
            centered
            open={open}
            onCancel={onClose}
            onOk={onRemove.onClick}
            okButtonProps={{ type: 'default', loading: onRemove.loading }}
            cancelButtonProps={{ type: 'primary' }}
        >
            <div className={`m-2 p-1 center-content`}>
                <p className="t-500 t-l-black1 t-h3">آیا از حذف این اگهی اطمینان دارید؟ </p>
            </div>
        </Modal>
    );
}
